import React from "react";
import profilePic from "../assets/profile1.png";
import useReveal from "./useReveal";

function About() {
  const [ref, inView] = useReveal();

  return React.createElement(
    "section",
    {
      id: "about",
      ref: ref,
      className: "about section reveal" + (inView ? " in-view" : ""),
    },
    React.createElement("img", {
      src: profilePic,
      alt: "Portrait of Van",
      className: "about-photo",
    }),
    React.createElement(
      "div",
      { className: "about-body" },
      React.createElement("p", { className: "eyebrow" }, "01 \u2014 About"),
      React.createElement("h2", { className: "section-title" }, "Hi, I'm Van!"),
      React.createElement(
        "p",
        null,
        "I'm a Cum Laude BS Information Technology graduate from MSU-IIT (major in Database Systems) who builds reliable, user-centered software \u2014 from Laravel CRM systems and automation workflows to AI-enhanced tools. I bring the same attention to detail to video editing and motion graphics, having spent years cutting content professionally alongside my dev work.",
      ),
      React.createElement(
        "p",
        null,
        "In my recent work experience, I served as an IT & Development Officer at M25 Systems Ltd (London, UK), maintaining production systems and building internal tools that save teams real time. I'm always exploring how AI, data, and design can work together to solve real problems \u2014 let's connect and build something.",
      ),
    ),
  );
}

export default About;
